<template>
  <v-layout>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="base"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar elevation="0">
            <v-toolbar-title>Base de datos clientes</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined icon color="green" v-bind="attrs" v-on="on" @click="listar()"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar tabla</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ml-5" @click="VerNuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="verDetalles(item)"
                v-bind="attrs"
                v-on="on"
              >
                tab
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackMensajeFechas" color="cyan darken-2" top
        >Debe de seleccionar ambas fechas.</v-snackbar
      >
      <v-snackbar v-model="snackError" color="yellow darken-3" top
        >Hubo un error, verificar conexión o recargar la pagina.</v-snackbar
      >

      <v-row v-if="verNuevo == 1 || verDet == 1" no-gutters>
        <v-col cols="12" class="pa-0">
          <v-toolbar elevation="1">
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="verNuevo == 1" @click="CerrarNuevo()"
              >Cerrar</v-btn
            >
            <v-btn
              color="primary"
              class="ml-5"
              v-if="verDet == 0"
              @click="guardar()"
              >Guardar</v-btn
            >
            <v-btn
              color="primary"
              class="ml-5"
              v-if="verDet == 1"
              @click="actualizar()"
              >Actualizar</v-btn
            >
          </v-toolbar>
        </v-col>
        <v-row class="pa-3">
          <v-col cols="4">
            <v-text-field
              v-model="nombre"
              label="NOMBRE CLIENTE"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="direccion" label="DIRECCION" counter="50"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="nit" label="NIT" counter="30"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="ncr" label="NCR" counter="30"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="giro" label="GIRO" counter="50"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="departamento"
              label="DEPARTAMENTO"
              counter="30"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      base: [],
      search: "",
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "NOMBRE DE CLIENTE",
          value: "nombre",
          align: "left",
        },
        {
          text: "DIRECCION",
          value: "direccion",
          align: "center",
        },
        {
          text: "NIT",
          value: "nit",
          align: "center",
        },
        {
          text: "NCR",
          value: "ncr",
          align: "center",
        },
        {
          text: "GIRO",
          value: "giro",
          align: "center",
        },
        {
          text: "DEPARTAMENTO",
          value: "departamento",
          align: "center",
        },
      ],
      verNuevo: 0,
      verDet: 0,
      snackMensajeFechas: false,
      snackError: false,
      overlay: false,
      idBaseClienteFactura: "",
      nombre: "",
      direccion: "",
      nit: "",
      ncr: "",
      giro: "",
      departamento: "",
    };
  },
  created() {
    this.listar();
  },
  methods: {
    VerNuevo() {
      this.verNuevo = 1;
    },
    CerrarNuevo() {
      this.verNuevo = 0;
      this.verDet = 0;
      this.limpiar();
    },
    verDetalles(item) {
      this.verNuevo = 1;
      this.verDet = 1;
      this.idBaseClienteFactura = item.idBaseClienteFactura;
      this.nombre = item.nombre;
      this.direccion = item.direccion;
      this.nit = item.nit;
      this.ncr = item.ncr;
      this.giro = item.giro;
      this.departamento = item.departamento;
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/BaseClientesFacturas/Listar", configuracion)
        .then(function (response) {
          me.base = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "api/BaseClientesFacturas/Crear",
          {
            nombre: me.nombre,
            nit: me.nit,
            direccion: me.direccion,
            ncr: me.ncr,
            giro: me.giro,
            departamento: me.departamento,
          },
          configuracion
        )
        .then(function (response) {
          me.CerrarNuevo();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    actualizar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/BaseClientesFacturas/Actualizar",
          {
            idBaseClienteFactura: me.idBaseClienteFactura,
            nombre: me.nombre,
            nit: me.nit,
            direccion: me.direccion,
            ncr: me.ncr,
            giro: me.giro,
            departamento: me.departamento,
          },
          configuracion
        )
        .then(function (response) {
          me.CerrarNuevo();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this.idBaseClienteFactura = "";
      this.nombre = "";
      this.direccion = "";
      this.nit = "";
      this.ncr = "";
      this.giro = "";
      this.departamento = "";
    },
  },
};
</script>